import { render, staticRenderFns } from "./CmgRewardsExchangeWelcomeModal.vue?vue&type=template&id=27a03be8&scoped=true&lang=pug&"
import script from "./cmg-rewards-exchange-welcome-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-rewards-exchange-welcome-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRewardsExchangeWelcomeModal.vue?vue&type=style&index=0&id=27a03be8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a03be8",
  null
  
)

export default component.exports